<template>
  <div>
    <b-row>
      <b-col cols="12" class="mb-4">
        <order-list
          title="Карточки на главной"
          description="Здесь показаны места с включённой настройкой «На главной»."
          :items="homepagePlaces"
          :loading="loading"
          :saving="savingHomepage"
          :visible-limit="4"
          @move="moveHomepagePlace"
          @edit="editPlace"
          @save="saveHomepagePlaces"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import { DisplayOrder } from '@/request';
import OrderList from '@/components/OrderList.vue';

export default Vue.extend({
  name: 'Homepage',
  components: { OrderList },
  data() {
    return {
      homepagePlaces: [],
      loading: true,
      savingHomepage: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.homepagePlaces = await DisplayOrder.getHomepagePlacesOrder();
      } catch (e) {
        this.showError(e);
      } finally {
        this.loading = false;
      }
    },
    move(list, { movedItemId, dropItemId, placement }) {
      const sourceIndex = list.findIndex(({ id }) => id === movedItemId);
      if (sourceIndex === -1 || movedItemId === dropItemId) return list;

      const reordered = [...list];
      const [item] = reordered.splice(sourceIndex, 1);
      const dropIndex = reordered.findIndex(({ id }) => id === dropItemId);
      const targetIndex = placement === 'after' ? dropIndex + 1 : dropIndex;
      reordered.splice(targetIndex, 0, item);

      return reordered;
    },
    moveHomepagePlace(moveEvent) {
      this.homepagePlaces = this.move(this.homepagePlaces, moveEvent);
    },
    async saveHomepagePlaces() {
      this.savingHomepage = true;
      try {
        this.homepagePlaces = await DisplayOrder.updateHomepagePlacesOrder(
          this.homepagePlaces.map(({ id }) => id),
        );
        this.$bvToast.toast('Порядок карточек сохранён', { variant: 'success' });
      } catch (e) {
        this.showError(e);
      } finally {
        this.savingHomepage = false;
      }
    },
    editPlace(place) {
      const routeName = place.place_type?.type === 'rest' ? 'EditPlaceTravel' : 'EditPlace';
      this.$router.push({ name: routeName, params: { id: place.id } });
    },
    showError(error) {
      const message = error.response?.data?.message || error.message;
      this.$bvToast.toast(message, { variant: 'danger' });
    },
  },
});
</script>
